import React from "react";

interface PageHeadingProps {
  title: string;
  description?: string;
}

const PageHeading: React.FC<PageHeadingProps> = ({ title, description }) => (
  <div className="mb-5 pb-5">
    <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
      {title}
    </h2>
    {description && (
      <p className="mt-2 max-w-4xl text-sm text-gray-500">{description}</p>
    )}
  </div>
);

export default PageHeading;
